import { useEffect, useState } from "react";
import { History } from "lucide-react";
import api from "@/lib/api";

const card = "bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl";

export default function Audit() {
  const [log, setLog] = useState(null);
  useEffect(() => { api.get("/admin/activity").then((r) => setLog(r.data)).catch(() => setLog([])); }, []);

  return (
    <div data-testid="audit-page">
      <h1 className="font-display text-4xl flex items-center gap-2"><History className="w-7 h-7 text-brand-red" /> Audit Log</h1>
      <p className="text-brand-ink/60 dark:text-white/50 mt-2">A record of important owner actions.</p>
      <div className={`${card} mt-8 overflow-hidden`}>
        {!log ? <div className="p-6 text-brand-ink/50">Loading…</div> : log.length === 0 ? <div className="p-6 text-brand-ink/50 dark:text-white/40" data-testid="audit-empty">No activity recorded yet.</div> : (
          <div className="divide-y divide-brand-line dark:divide-neutral-800">
            {log.map((a, i) => (
              <div key={i} className="px-6 py-3.5 flex items-center justify-between gap-3 text-sm" data-testid={`audit-${i}`}>
                <div><span className="font-medium">{a.action}</span> <span className="text-brand-ink/40 dark:text-white/40">· {a.admin}</span></div>
                <div className="text-xs text-brand-ink/40 dark:text-white/40">{(a.at || "").slice(0, 16).replace("T", " ")}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
